var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8437,
    cy: 20.25,
    r: 19.1297,
    fill: "white",
    stroke: "#42296E",
    strokeWidth: 1.42804
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11143_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5786 17.7959H30.5395V12.835",
    stroke: "#42296E",
    strokeWidth: 2.06705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5786 17.7959H30.5395V12.835",
    stroke: "#42296E",
    strokeWidth: 2.06705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0333 26.8912C24.7331 28.118 23.1003 28.9345 21.3388 29.2386C19.5772 29.5428 17.7651 29.3211 16.1289 28.6012C14.4926 27.8814 13.1048 26.6953 12.1387 25.1912C11.1727 23.6872 10.6713 21.9318 10.6972 20.1444C10.7232 18.3569 11.2752 16.6168 12.2844 15.1414C13.2937 13.6659 14.7153 12.5206 16.3717 11.8485C18.0282 11.1764 19.8459 11.0073 21.5979 11.3624C23.3499 11.7175 24.9584 12.5809 26.2224 13.8449L30.5395 17.7961",
    stroke: "#42296E",
    strokeWidth: 2.06705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0333 26.8912C24.7331 28.118 23.1003 28.9345 21.3388 29.2386C19.5772 29.5428 17.7651 29.3211 16.1289 28.6012C14.4926 27.8814 13.1048 26.6953 12.1387 25.1912C11.1727 23.6872 10.6713 21.9318 10.6972 20.1444C10.7232 18.3569 11.2752 16.6168 12.2844 15.1414C13.2937 13.6659 14.7153 12.5206 16.3717 11.8485C18.0282 11.1764 19.8459 11.0073 21.5979 11.3624C23.3499 11.7175 24.9584 12.5809 26.2224 13.8449L30.5395 17.7961",
    stroke: "#42296E",
    strokeWidth: 2.06705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11143_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4583,
    height: 26.4583,
    fill: "white",
    transform: "translate(6.56201 7.04736)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkRefreshIcon);
export default __webpack_public_path__ + "static/media/network_refresh_icon.2d01c61389d5ad6a3dd6f642a69fb0b2.svg";
export { ForwardRef as ReactComponent };